import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Privacidade from "../pages/privacidade/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacidade",
    element: <Privacidade />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
